import { render, staticRenderFns } from "./addRegionArea.vue?vue&type=template&id=e0071ba2&scoped=true&"
import script from "./addRegionArea.vue?vue&type=script&lang=js&"
export * from "./addRegionArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0071ba2",
  null
  
)

export default component.exports